import React from 'react';
import { FormControl, FormGroup } from 'react-bootstrap';
import { find } from 'lodash';
import IconTooltip from './IconTooltip';
import { handleNegativeInput, replaceExpression } from '../utils';
import { CollaboratorsContext } from '../context/CollaboratorsContext';
import Collaboration from './Collaboration';
import CheckmarkQuestionAnswered from './CheckmarkQuestionAnswered';
import * as answerService from "../services/answer-service";

function TableColumn(props) {
  const { option, completed, onChange, answermap, value, maxValue, originalValue, valid } = props;

  return (
      <div className="col">
        <div className="form-numeric form-numeric-inline">
          {replaceExpression(option.optionText, answermap) && (
              <div
                  className="text"
                  dangerouslySetInnerHTML={{
                    __html: replaceExpression(option.optionText, answermap),
                  }}
              ></div>
          )}
          <FormControl
              type="number"
              min={option.minValue}
              onKeyDown={handleNegativeInput}
              disabled={completed}
              value={value}
              placeholder={`Vul een getal in: ${option.minValue} - ${maxValue}`}
              onChange={(e) => onChange(e, option.id, false)}
              onBlur={(e) => onChange(e, option.id, true)}
              className={valid ? 'valid' : 'invalid'}
          />
          {originalValue && (
              <span className="original">De originele waarde is: {originalValue}</span>
          )}
        </div>
      </div>
  );
}

export default class NumericQuestion extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      rows: [],
      allComments: [],
      comment: '',
      originalState: {},
    };
  }

  componentDidMount() {
    var scanId = (this.props.analyse === true)
        ? this.props.originalState[0].scanId
        : (this.props.state && this.props.state[0] ? this.props.state[0].scanId : null);

    if (scanId) {
      answerService.getComments(scanId)
          .then((allComments) => {
            this.setState({ allComments });
            const questionComment = allComments.find(comment => comment.questionId === this.props.data.id);
            if (questionComment) {
              this.setState({ comment: questionComment.comment });
            }
          })
          .catch((error) => {
            console.error("Error fetching comments:", error);
          });
    }

    if (this.props.data && this.props.data.options) {
      this.prepareTable(this.props.data);
    }

    this.trackOriginalValues();
  }

  trackOriginalValues() {
    const { state } = this.props;

    if (state && state.length > 0) {
      const originalState = {};
      state.forEach((item) => {
        if (item.optionId && item.stringValue) {
          originalState[item.optionId] = item.stringValue;
        }
      });
      this.setState({ originalState });
    }
  }

  prepareTable(question) {
    let currentRow = { row: 0 };
    let rows = [];

    question.options.forEach((option) => {
      if (currentRow.row !== option.row) {
        currentRow = { row: option.row, columns: [] };
        rows.push(currentRow);
      }
      currentRow.columns.push(option);
    });

    // Update the state with the rows
    this.setState({ rows: rows });
  }

  handleExplanationChange = (e, data) => {
    const updatedExplanation = e.target.value;

    // Update local state
    this.setState({ comment: updatedExplanation });

    // Save the updated explanation to the backend
    answerService.updateAnswer({
      scanId: this.props.state[0].scanId,
      questionId: data.id,
      comment: updatedExplanation,
    }).catch((error) => {
      console.error("Error updating explanation:", error);
    });
  };

  getExplanationValue() {
    return this.state.comment;
  }

  obtainAnsweredCheckDOM(optionIds) {
    return <CheckmarkQuestionAnswered checked={this.questionHasValidAnswers(optionIds)} />;
  }

  questionHasValidAnswers(optionIds) {
    let valid = true;
    optionIds.forEach((optionId) => {
      valid &= this.checkOptionNumericValue(optionId);
    });

    return valid;
  }

  getValidationState(optionIds) {
    return this.questionHasValidAnswers(optionIds) ? 'success' : 'error';
  }

  checkOptionNumericValue(optionId) {
    const value = this.getValue(optionId);
    let valid = true;

    if (!value) {
      valid = false;
    } else {
      const option = this.getOption(optionId);
      const minValue = option.minValue;
      const maxValue = this.getQuestionMaxValue(optionId);
      if (value > maxValue || value < minValue) {
        valid = false;
      }
    }

    return valid;
  }

  getValue(optionId) {
    const value = find(this.props.state, (s) => s.optionId === optionId);
    return value && value.stringValue;
  }

  getOption(optionId) {
    return find(this.props.data.options, (o) => o.id === optionId);
  }

  getQuestionMaxValue(optionId) {
    const { data } = this.props;
    const option = find(data.options, (o) => o.id === optionId);

    if (option) {
      const maxValue = data.questionMaxValue;
      return maxValue;
    }
  }

  getOriginalValue(optionId) {
    const { originalState } = this.state;

    return originalState[optionId] || ''; // Default message if not found
  }


  handleValueChange = (e, optionId, blur = false) => {
    const updatedValue = e.target.value;


    this.setState(prevState => {
      const updatedOriginalState = { ...prevState.originalState };

      updatedOriginalState[optionId] = updatedValue;

    });

    this.props.onChange(e, optionId, blur);
  };

  render() {
    const { data, completed, answermap, onChange, isIntroQuestions } = this.props;
    const { rows, comment } = this.state;
    const optionIds = data.options.map((option) => option.id);

    return (
        <div className="question-group type-numeric row">
          <div className="col">
            <form>
              <span>
              {replaceExpression(data.questionText, answermap)}
                <div className="indicator-container">
                <IconTooltip
                    text={replaceExpression(data.explanation, answermap)}
                    icon="far fa-info-circle"
                />
                  {this.obtainAnsweredCheckDOM(optionIds)}
              </div>
            </span>

              {/* Render the rows and columns of options */}
              <FormGroup controlId="formNummer" validationState={this.getValidationState(optionIds)}>
                <div>
                  {rows.length === 0 ? (
                      <p>No options available</p>
                  ) : (
                      rows.map((row) => (
                          <div className="row" key={row.row}>
                            {row.columns.map((option) => (
                                <TableColumn
                                    key={option.column}
                                    option={option}
                                    completed={completed}
                                    onChange={this.handleValueChange}
                                    answermap={answermap}
                                    value={this.getValue(option.id)}
                                    maxValue={this.getQuestionMaxValue(option.id)}
                                    originalValue={this.getOriginalValue(option.id)}
                                    valid={this.checkOptionNumericValue(option.id)}
                                />
                            ))}
                          </div>
                      ))
                  )}
                </div>
              </FormGroup>

              <div className="form-group">
                <label style={{fontWeight: 'normal'}}>Toelichting:</label>
                <FormControl
                    as="textarea"
                    rows={3}
                    value={comment}
                    onChange={(e) => this.handleExplanationChange(e, data)}
                    disabled={completed || this.props.analyse }
                />
              </div>
            </form>
          </div>

          {
              !isIntroQuestions && (
                  <CollaboratorsContext.Consumer>
                    {(context) => (
                        <Collaboration
                            data={data}
                            answermap={answermap}
                            collaborators={context.state.collaborators}
                            scanId={context.state.scanId}
                        />
                    )}
                  </CollaboratorsContext.Consumer>
              )}
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NumericQuestion.js